import service from "../../api/FetchInterceptor";
import {useEffect, useState} from "react";
import {Button, Drawer, Form, Input, message, Upload, Select} from "antd";
import { Editor } from "@tinymce/tinymce-react";
import { UploadOutlined } from "@ant-design/icons";

const formDataHeaders = {
    ...service.defaults.headers,
    "Content-Type": "multipart/form-data",
};

const AddPublication = ({ id = null, open, setOpen, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [description, setDescription] = useState("");
    const [create, setCreate] = useState({
        types: [],
    });

    const isEdit = !!id;

    const loadCreate = () => {
        service({
            method: "GET",
            url: "/publications/create",
        }).then((response) => {
            setCreate(response);
        });
    };

    const loadPublication = () => {
        if (!id) return;

        service({
            method: "GET",
            url: `/publications/${id}`,
        }).then((response) => {
            const data = response.data ?? response;

            setDescription(data.body || "");
            form.setFieldsValue({
                type_id: data.type_id,
                title: data.title,
                description: data.body,
                youtube_link: data.youtube_link || "",
            });
        });
    };

    useEffect(() => {
        if (open) {
            loadCreate();
            if (isEdit) {
                loadPublication();
            } else {
                setDescription("");
                form.resetFields();
            }
        } else {
            setDescription("");
            form.resetFields();
        }
    }, [open, id]);

    const onSubmit = (values) => {
        setLoading(true);

        const payload = {
            ...values,
            body: description,
        };

        if (values.files && values.files.fileList) {
            payload.files = values.files.fileList.map((item) => item.originFileObj);
        }

        if (isEdit) {
            payload._method = "PUT";
        }

        service({
            method: "POST",
            url: isEdit ? `publications/${id}` : "publications",
            data: payload,
            headers: formDataHeaders,
        })
            .then((response) => {
                const data = response.data ?? response;
                message.success({ content: data.message, duration: 2 });

                form.resetFields();
                setDescription("");
                setOpen(false);
                onSuccess();
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Drawer
            title={isEdit ? "Modifier une publication" : "Ajouter une publication"}
            open={open}
            onClose={() => setOpen(false)}
            width={700}
        >
            <Form form={form} onFinish={onSubmit} layout="vertical">
                <Form.Item
                    label="Type de publication"
                    name="type_id"
                    rules={[{ required: true }]}
                >
                    <Select
                        placeholder="Sélectionner le type"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {create.types.map((b) => (
                            <Select.Option key={b.id} value={b.id}>
                                {b.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="title"
                    label="Titre de la publication"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Contenu"
                    rules={[{ required: true }]}
                >
                    <Editor
                        apiKey="wocwl2pci23dc7619bcf0b8dmmaglua4dprthqoqnif0fako"
                        value={description}
                        onEditorChange={(content) => {
                            setDescription(content);
                            form.setFieldsValue({ description: content });
                        }}
                        init={{
                            height: 300,
                            menubar: false,
                        }}
                    />
                </Form.Item>

                <Form.Item
                    name="files"
                    label="Pièces jointes du document"
                    rules={isEdit ? [] : [{ required: true }]}
                >
                    <Upload
                        multiple
                        maxCount={5}
                        accept=".pdf"
                        beforeUpload={() => false}
                    >
                        <Button icon={<UploadOutlined />}>
                            Sélectionnez les fichiers
                        </Button>
                    </Upload>
                </Form.Item>

                <Form.Item
                    name="youtube_link"
                    label="Lien de la vidéo youtube"
                >
                    <Input />
                </Form.Item>

                <Button loading={loading} type="primary" htmlType="submit">
                    {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
            </Form>
        </Drawer>
    );
};

export default AddPublication;
